import { render } from "./PokemonOptions.vue?vue&type=template&id=7d04a3af&scoped=true"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=7d04a3af&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Desktop\\Cursos\\11 Vue\\04-pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d04a3af"]])

export default __exports__